/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_AiInputs */

const cs_settings_office_ai = /** @type {(inputs: Settings_Office_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapnout AI funkce`)
};

const en_settings_office_ai = /** @type {(inputs: Settings_Office_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable AI features`)
};

/**
* | output |
* | --- |
* | "Enable AI features" |
*
* @param {Settings_Office_AiInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_ai = /** @type {((inputs?: Settings_Office_AiInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_AiInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_ai(inputs)
	return cs_settings_office_ai(inputs)
});